module.exports = __webpack_public_path__ + "static/media/A_iko_2_czcionka_active_1.892aa4c0.svg";